import { ErrorBoundary } from "@sentry/react";
import { contentMain } from "plos/src/layouts";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

const UpdatingErrorFallback = () => {
  const { t } = useTranslation();
  return (
    <div className={contentMain}>
      <h4>
        {t(
          "updatingErrorBoundary.title",
          "The game is updating and will be available soon.",
        )}
      </h4>
      <p>
        {t(
          "updatingErrorBoundary.message",
          "Please try again later when the updated scores / teams will be available.",
        )}
      </p>
    </div>
  );
};

const UpdatingErrorBoundary = ({ children }: { children?: ReactNode }) => (
  <ErrorBoundary fallback={<UpdatingErrorFallback />}>{children}</ErrorBoundary>
);

export default UpdatingErrorBoundary;
